import SilentThunkError from './SilentThunkError';

/* eslint-disable no-console */
export default (trigger, effect, { once = false } = {}) => {
  if (typeof trigger !== 'string') {
    throw new Error(`Invalid createListenerEffect \`trigger\`. Expected String, received ${typeof trigger}`);
  }
  if (!(effect instanceof Function)) {
    throw new Error(`Invalid createListenerEffect \`effect\`. Expected Function, received ${typeof effect}`);
  }

  return async (action, listenerApi) => {
    try {
      if (once) {
        listenerApi.unsubscribe();
      }

      await effect(action, { ...listenerApi, trigger });
    } catch (e) {
      // NOTE: If listenerApi.cancelActiveListeners is invoked it throws a TaskAbortError with code 'listener-cancelled'
      const silent = e instanceof SilentThunkError || e?.silent || e?.code === 'listener-cancelled';
      if (silent) return;

      console.error(e);
      console.error(`The above error occurred in the ${trigger} listener`);
    }
  };
};
